import TableRow from './TableRow';
import { IColumn, IData } from './types';
import TotalCost from 'components/Layout/Mining/MiningCalculator/TotalCost';

interface IStaticTable {
  columns: IColumn[];
  data?: IData[];
  className?: string;
  totalProfit: number;
  isCalculatorModifiedByUser: boolean;
}

const StaticTable = (props: IStaticTable) => {
  const { columns, data, totalProfit, isCalculatorModifiedByUser } = props;

  return (
    <div className="static-table__wrapper">
      <TotalCost
        totalProfit={totalProfit}
        isCalculatorModifiedByUser={isCalculatorModifiedByUser}
      />
      <table className="static-table">
        <thead className="static-table__header">
          <tr className="static-table__row static-table__header-row">
            {columns.map((column, index) => (
              <th key={index} className={column.headerClassName}>
                <div className="static-table__header-cell">
                  <div className="static-table__header-cell-content">
                    <span className="static-table__header-title">
                      {column.header.title}
                    </span>
                    {column.header.description && (
                      <span className="static-table__header-description">
                        {column.header.description}
                      </span>
                    )}
                  </div>
                </div>
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="static-table__body">
          {data?.map((rowData, index) => (
            <TableRow
              key={index}
              rowIndex={index}
              columns={columns}
              data={rowData}
            />
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default StaticTable;
